import { computed } from "vue";
import { i18n } from "../i18n";
import { useClientStore } from "../store/client";
import defaultProfile from "./default";
import type { ConfigSection, GameProfile, ProfileCtx } from "./types";

const { t } = i18n.global;

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "branch" } },
  { component: "ConfSection", props: { name: "basic" } },
];

const join = () => {
  window.open(t("ngp/settings/section/hell_let_loose_wiki/link"), "_blank", "noopener,noreferrer");
};

const extra = () => {
  window.open("https://cdn.g-portal.com/HLL_RCON.zip");
};

function getIsAdmin() {
  const client = useClientStore();
  const isAdmin = computed(() => client.me?.jwt.hasAllServiceAccess);
  return isAdmin.value;
}

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: defaultProfile().menu,
  configSections,
  join: {
    buttonTextKey: "ngp/settings/section/hell_let_loose_wiki",
    joinFn: join,
  },
  extraHeaderButton: {
    buttonTextKey: "ngp/settings/section/hell_let_loose/rcon_tool_download",
    btnFn: extra,
  },
  statusPageConfig: {
    ...defaultProfile(_ctx).statusPageConfig,
    showFtp: getIsAdmin(),
  },
});
